import { ProfilePenName } from './ProfilePenName'
import { withProfilePenName } from './withProfilePenName'

const ConnectedProfilePenName = withProfilePenName(ProfilePenName)

export { ConnectedProfilePenName as ProfilePenName }
